export default __webpack_public_path__ + "images/18_2_image.jpg";